<template>
  <v-sheet 
    outlined 
    min-height="90vh"
    class="d-flex justify-center align-center in-progress">

    <v-row class="text-center">

      <v-col 
        cols="12" 
        v-if="$vuetify.breakpoint.xsOnly">
        <h2 class="font-weight-regular text--secondary pl-8 pr-8">
          Les damos la bienvenida a la convocatoria de proyectos para las  <b>{{ edition.edition.short_name }}</b>
        </h2>
      </v-col>

      <v-col 
        cols="12" 
        class="headline text--secondary pl-4 pr-4"
        v-if="!$vuetify.breakpoint.xsOnly">
        Les damos la bienvenida a la convocatoria de proyectos para las  <b>{{ edition.edition.short_name }}</b>
      </v-col>
    
      <v-col cols="12">
        <v-img 
          v-if="imageLoaded" 
          :src="imageUrl" 
          contain
          height="320"
          alt="JIJE"
        />
      </v-col>

      <v-col cols="12" class="mb-8 mt-3 pl-8 pr-8 text-center">
        <h3 class="font-weight-regular text--secondary">La inscripción de proyectos para esta edición cierra en:</h3>
        
        <Countdown 
          :date="end" 
          @onFinish="finish()"
          :style="countdownStyle">
        </Countdown>
        
        <p class="subheading font-weight-regular pt-8 pa-4 text--secondary">
          A continuación deben completar la carga de su proyecto y del equipo
          emprendedor (en caso de que corresponda). Al finalizar la carga, no 
          olviden darle clic al botón de <b>ENVIAR</b> <i>¡para que pueda ser evaluado!</i>
        </p>
      </v-col>

      <v-col cols="12" class="mb-1">
        <v-btn color="red" dark large to="/convocation">
          <v-icon>mdi-arrow-up-circle-outline</v-icon> 
          Continuar mi carga
        </v-btn>
      </v-col>

    </v-row>
  </v-sheet>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  import Countdown from "@/components/Countdown";
  
  export default {
    name: 'entrepreneurInProgress',
    components: {
      Countdown
    },
    data: () => ({
      loading:true,
      rocket:null,

      imageUrl: require('@/assets/icons/gif_jije.gif'),
      imageLoaded: false,

      time_left:null,
      end: null
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'edition'
      ]),

      countdownStyle() {
        return {
          zoom: this.$vuetify.breakpoint.xs ? '90%' : '140%'
        };
      }
    },
    methods:{
      finish() {
        console.log("finish");
      },
      
      async getEdition(){
        let edition_id = this.convocation_form.convocation_form.edition_id
        await axios.get('edition/'+edition_id).then(response =>{
          this.edition = response.data.data.edition
          let aux = this.edition.finish_date_entrepreneurs+'T'+this.edition.finish_time_entrepreneurs
          this.end = new Date(aux)
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },
    },
    mounted() {
      const image = new Image();
      image.onload = () => {
        this.imageLoaded = true;
        
      };
      image.src = this.imageUrl;
    },
    created(){
      let aux = this.edition.edition.finish_date_entrepreneurs+'T'+this.edition.edition.finish_time_entrepreneurs
      this.end = new Date(aux)
    }
  }
</script>
<style scoped>
.in-progress{
  padding-top: 82px;
  padding-bottom: 82px;
}
</style>